export interface VoiceBudget {
  checkVoiceBudget(ownerId: string): Promise<{ allowed: boolean; remainingUsd?: number }>;
  recordVoiceUsage(ownerId: string, usd: number): Promise<void>;
}

// Missing persistence must fail closed; composition roots bind the durable ledger.
const defaultBudget: VoiceBudget = {
  async checkVoiceBudget() {
    return { allowed: false };
  },
  async recordVoiceUsage() {
    throw new Error("Voice budget persistence is required.");
  },
};

/** Inject a durable budget at the composition root; the core has no hosted dependency. */
export function createVoiceBudget(budget: VoiceBudget = defaultBudget): VoiceBudget {
  return budget;
}
export const { checkVoiceBudget, recordVoiceUsage } = defaultBudget;
